<template>
  <v-layout>
    <v-flex>
      <v-text-field
        v-model="maxPrice"
        clearable
        @keyup.enter="getSimilarItems"
        label="Precio máximo"
        prepend-icon="arrow_upward"
        :rules="[mustBeNumber]"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const { mapActions, mapMutations, mapState } = createNamespacedHelpers(
  "matching"
);

export default {
  computed: {
    ...mapState(["similarItemsFilters"]),
    maxPrice: {
      get() {
        return this.similarItemsFilters.maxPrice;
      },
      set(price) {
        price = Number(price);
        if (price && !Number.isNaN(price)) {
          this.setSimilarItemsFiltersMaxPrice(Number(price));
        } else {
          this.setSimilarItemsFiltersMaxPrice(null);
        }
      }
    }
  },
  methods: {
    ...mapActions(["getSimilarItems"]),
    ...mapMutations(["setSimilarItemsFiltersMaxPrice"]),
    mustBeNumber(value) {
      return !Number.isNaN(Number(value)) || "El precio debe ser un número";
    }
  }
};
</script>